// Copyright 2026 Hardfin, Inc.
import { EntityNotFound } from '@/components/entity-not-found';

export function AppNotFound() {
  return (
    <EntityNotFound
      entityType="page"
      listPath="/"
      listLabel="Go home"
      showBackButton={true}
    />
  );
}
